// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollTopBtn_container__MsVNJ","icon":"ScrollTopBtn_icon__2J7jp"};